import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import profileImage from './profile.jpg';
import hobImage from './hob_image.png';
import { SkillCloud } from './SkillCloud.tsx';
import nvidiaLogo from './nvidia.png';
import appleLogo from './apple.png';
import shopifyLogo from './shopify.png';
import mawariLogo from './mawari.png';
import waterlooLogo from './uwaterloo-logo.png';

const TerminalBox = ({ children, className = '' }) => {
  return (
    <div className={`term-window ${className}`}>
      <div className="term-bar">
        <div className="term-dots">
          <span className="term-dot dot-red"></span>
          <span className="term-dot dot-yellow"></span>
          <span className="term-dot dot-green"></span>
        </div>
      </div>
      <div className="term-body">
        {children}
      </div>
    </div>
  );
};

function About() {
  return (
    <div className="about">
      {/* SECTION 1: Intro Terminal & Profile */}
      <div className="terminal-section">
        <TerminalBox>
          <div className="term-cmd-row">
            <span className="t-green">ayaannadamal</span> <span className="t-green">$</span> <span className="t-white">cat aboutayaan</span>
          </div>
          <div className="term-cmd-row t-sub-prompt">
            <span className="t-green">aboutayaan</span> <span className="t-green">(main)</span> <span className="t-green">$</span>{' '}
            <span className="t-white">
              Hi, I'm Ayaan! I'm driven by a passion for learning & building cool and innovative things. Incoming Software Engineer Intern at <img src={nvidiaLogo} alt="NVIDIA" className="t-inline-logo" /> <a href="https://www.nvidia.com" target="_blank" rel="noopener noreferrer" className="t-highlight-company">NVIDIA</a> (AI Inference Systems) this Fall 2026 & previously: Machine Learning Intern at <img src={appleLogo} alt="Apple" className="t-inline-logo" /> <a href="https://www.apple.com" target="_blank" rel="noopener noreferrer" className="t-highlight-company">Apple</a> (On-Device ML Compilers), Software Engineer Intern at <img src={shopifyLogo} alt="Shopify" className="t-inline-logo" /> <a href="https://www.shopify.com" target="_blank" rel="noopener noreferrer" className="t-highlight-company">Shopify</a>, and Software Developer Intern at <img src={mawariLogo} alt="Mawari" className="t-inline-logo" /> <a href="https://mawari.net" target="_blank" rel="noopener noreferrer" className="t-highlight-company">Mawari</a>. I'm also pursuing Computer Science at the <img src={waterlooLogo} alt="University of Waterloo" className="t-inline-logo" /> <a href="https://uwaterloo.ca" target="_blank" rel="noopener noreferrer" className="t-highlight-uni">University of Waterloo</a>. Outside of coding, I love staying active with literally any sports, numismatics, trying delicious food, testing my wits in escape rooms, and tackling challenging math and CS problems. I'm always open to connecting and discussing new ideas, feel free to reach out to me and have fun exploring <Link to="/" className="t-highlight-aurora">Ayaan's Space Realm</Link>!
            </span>
          </div>
        </TerminalBox>
        <img src={profileImage} alt="Profile" className="related-image" id="profile-image" />
      </div>

      {/* SECTION 2: Skills Cloud & Skills Terminal */}
      <div className="terminal-section">
        <div className="related-image skill-cloud-container">
          <SkillCloud />
        </div>

        <TerminalBox>
          <div className="term-cmd-row">
            <span className="t-green">ayaannadamal</span> <span className="t-green">$</span> <span className="t-white">cd skills/tools</span>
          </div>
          <div className="term-cmd-row">
            <span className="t-green">skills/tools</span> <span className="t-green">(main)</span> <span className="t-green">$</span> <span className="t-white">ls</span>
          </div>

          <div className="t-section-label">Languages</div>
          <div className="t-grid-cols">
            <div className="t-col">
              <div>C++</div>
              <div>C</div>
              <div>Python</div>
              <div>Golang</div>
              <div>Rust</div>
              <div>Ruby</div>
            </div>
            <div className="t-col">
              <div>TypeScript</div>
              <div>JavaScript</div>
              <div>Java</div>
              <div>Bash</div>
              <div>SQL</div>
              <div>Scheme</div>
            </div>
          </div>

          <div className="t-section-label">Tools</div>
          <div className="t-grid-cols">
            <div className="t-col">
              <div>LLVM / MLIR</div>
              <div>CUDA / CUTLASS</div>
              <div>vLLM</div>
              <div>PyTorch / JAX</div>
              <div>React / Node</div>
              <div>Linux</div>
            </div>
            <div className="t-col">
              <div>Docker / QEMU</div>
              <div>OP-TEE (TrustZone)</div>
              <div>Git</div>
              <div>WebRTC</div>
              <div>Redis / Postgres</div>
              <div>GCP / AWS</div>
            </div>
          </div>
        </TerminalBox>
      </div>

      {/* SECTION 3: Hobbies Terminal & Hobbies Showcase */}
      <div className="terminal-section">
        <TerminalBox>
          <div className="term-cmd-row">
            <span className="t-green">ayaannadamal</span> <span className="t-green">$</span> <span className="t-white">cd hobbies/interests</span>
          </div>
          <div className="term-cmd-row">
            <span className="t-green">hobbies/interests</span> <span className="t-green">(main)</span> <span className="t-green">$</span> <span className="t-white">ls</span>
          </div>

          <div className="t-hobbies-list">
            <div className="t-hobby-item">
              <span className="t-hobby-icons">💵 💷 💶</span>
              <span className="t-hobby-text">numismatics</span>
            </div>
            <div className="t-hobby-item">
              <span className="t-hobby-icons">🍣 🌶️ 🍕</span>
              <span className="t-hobby-text">eating</span>
            </div>
            <div className="t-hobby-item">
              <span className="t-hobby-icons">💻 📱 📸</span>
              <span className="t-hobby-text">coding</span>
            </div>
            <div className="t-hobby-item">
              <span className="t-hobby-icons">🏸 🏐 🎾</span>
              <span className="t-hobby-text">sports</span>
            </div>
          </div>
        </TerminalBox>

        <img src={hobImage} alt="Hobbies" className="related-image" id="profile-image" />
      </div>
    </div>
  );
}

export default About;
